require('./creditModifyAssociatedAccountView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
//const { bindActionCreators } = require('redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { formatText } = require('core/i18n').i18n;
// @ components
const CreditModifyAssociatedAccountStep1 = require('components/contactCenter/creditModifyAssociatedAccountSteps/creditModifyAssociatedAccountStep1/creditModifyAssociatedAccountStep1');
const CreditModifyAssociatedAccountStep2 = require('components/contactCenter/creditModifyAssociatedAccountSteps/creditModifyAssociatedAccountStep2/creditModifyAssociatedAccountStep2');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const CreditModifyAssociatedAccountSuccessStep = require('components/contactCenter/creditModifyAssociatedAccountSteps/creditModifyAssociatedAccountSuccessStep/creditModifyAssociatedAccountSuccessStep');
const CreditModifyAssociatedAccountErrorStep = require('components/contactCenter/creditModifyAssociatedAccountSteps/creditModifyAssociatedAccountErrorStep/creditModifyAssociatedAccountErrorStep');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
// @ actions
const modifyCardActions = require('actions/contactCenter/creditModifyAssociatedAccountActions');
const { getCreditCardCurrentAccounts } = require('utilities/currentAccountsHelper.js');
const profileActions = require('actions/profile');
// @ constants
const { WIZARD_VERTICAL_VIEW_MODE, FIRST_STEP } = require('constants/index');

class CreditModifyAssociatedAccountView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.buildError = this.buildError.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { match: { params: { cardId } }, immCards, setCurrentAccount, immAccountsState } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const associatedAccountNumber = immCard.get('associatedAccount').replace(/ /g, '');
        setCurrentAccount(associatedAccountNumber);
        const accounts = immAccountsState.get('byId');
        const immAccount = accounts.filter(account => account.getIn(['ibanComplex', 'codbban']) === associatedAccountNumber).first();
        if (immAccount !== undefined) {
            const accountId = immAccount.get('accountId');
            this.props.getAssociatedAccountDetails(cardId, accountId);
        }
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }

    isReady() {
        const { immCreditCardModifyAccountState } = this.props;
        !immCreditCardModifyAccountState.get('isFetching');
    }

    handleCancel() {
        const { history, match: { params: { cardId } } } = this.props;
        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    handleFinish() {
        const { match: { params: { cardId } }, immCreditCardModifyAccountState } = this.props;
        const immStepOne = immCreditCardModifyAccountState.getIn(['steps', FIRST_STEP]);
        let newAccountId = immStepOne.get('newAccountId')
        this.props.postModify(cardId, newAccountId);
    }

    buildCustomMessageBoxSuccess() {
        const title = formatText('profileKeysLanding-titleMessageBoxSuccess');
        const extraContent = <BlockInfo>{formatText('profileKeysLanding-extraContentMessageBox')}</BlockInfo>

        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                extraContent={extraContent}
            />
        )
    }

    buildWizard() {
        const { match: { params: { cardId } }, immCards, validateStep, setNewAccount, immProfileFields, immCreditCardModifyAccountState, immAccountsState, modifyCardActions, setVisibleStep, setWillCancel } = this.props;
        const immSteps = immCreditCardModifyAccountState.get('steps');
        const stepsAmount = immSteps.size;
        const immCard = immCards.get('byId').get(cardId);
        const actions = {
            validateStep: validateStep,
            setVisibleStep: setVisibleStep,
            setWillCancel: setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        const associatedAccountNumber = immCard.get('associatedAccount').replace(/ /g, '');
        let visibleStep = immCreditCardModifyAccountState.get('visibleStep');
        const immStepOne = immCreditCardModifyAccountState.getIn(['steps', FIRST_STEP]);
        let newAccountId = immStepOne.get('newAccountId');
        let isFetching = immCreditCardModifyAccountState.get('isFetching');
        const accountsById = immAccountsState.get('byId');
        const accountsIndexes = getCreditCardCurrentAccounts(immAccountsState.get('byOrder').toJS(), accountsById, associatedAccountNumber);
        const immFinalButton = 'sendN1PasswordStep1-confirmBtn';

        return (
            <Wizard
                wizardClass="account-modify__wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                isFetching={isFetching}
                fullWidth={false}
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={immCreditCardModifyAccountState.get('isValidating')}
                    rightIconModifier={false}
                    nextBtnModifier="primary"
                >
                    <CreditModifyAssociatedAccountStep1
                        immAccounts={accountsById}
                        immAccountsState={accountsById}
                        immStep={immSteps.get(0)}
                        accountsIndexes={accountsIndexes}
                        actions={modifyCardActions}
                        immCard={immCard}
                        immProfileFields={immProfileFields}
                        setNewAccount={setNewAccount}
                        immCreditCardModifyAccountState={immCreditCardModifyAccountState}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    position="last"
                    cancelButton={true}
                    isLoading={isFetching}
                    finishButton={true}
                    omitPreviousButton={true}
                    immFinalButton={immFinalButton}
                >
                    <CreditModifyAssociatedAccountStep2 newAccountId={newAccountId} immAccounts={accountsById} immCard={immCard} />
                </WizardStep>
            </Wizard>
        );
    }

    buildSuccessful() {
        return (
            <CreditModifyAssociatedAccountSuccessStep />
        )
    }

    buildError() {
        return (
            <CreditModifyAssociatedAccountErrorStep />
        );
    }

    beforeLeaving() {
        const { immCreditCardModifyAccountState, reset } = this.props;
        if (immCreditCardModifyAccountState.get('submitSuccessful') && immCreditCardModifyAccountState.get('willLeave')) {
            reset();
        }
    }

    buildEmptyOriginAccounts() {
        const title = formatText('mytransfers-noFromAccountsTitle');
        const primaryText = formatText('mytransfers-noFromAccountsMessage');
        const linkText = formatText('mytransfers-errorBackToTransfersLink');
        const backToTransfersLink = '/myprofile/transfers';
        return (
            <div className="row">
                <OKSectionBox className="col-xs-12">
                    <section className="">
                        <section className="">
                            <EmptyState
                                title={title}
                                primaryText={primaryText}
                                linkText={linkText}
                                linkURL={backToTransfersLink}
                            />
                        </section>
                    </section>
                </OKSectionBox>
            </div>
        );
    }

    render() {
        const { match: { params: { cardId } }, immCards, immCreditCardModifyAccountState, immAccountsState } = this.props;
        const accountsList = immAccountsState.get('byOrder');
        const immCard = immCards.get('byId').get(cardId);
        const pageTitle = formatText('accountModifyStep-pageTitle');
        let passContent = (<div></div>);
        let content;

        if (immCreditCardModifyAccountState.get('error')) {
            content = this.buildError();
        } else if (immCreditCardModifyAccountState.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else if (accountsList.size > 1) {
            const wizard = this.buildWizard();
            const confirmationMessage = formatText('preleaveCancelModal-confirmationMessagePreleave');
            const confirmationTitle = formatText('preleaveCancelModal-confirmationTitleMessagePreleave');
            const acceptText = formatText('preleaveCancelModal-cancelButton');
            const cancelText = formatText('preleaveCancelModal-stayHereButton');

            passContent = (
                <div>
                    <PreLeaveModalComponent
                        confirmationMessage={confirmationMessage}
                        confirmationTitle={confirmationTitle}
                        acceptText={acceptText}
                        cancelText={cancelText}
                        isReady={this.isReady}
                        beforeLeaving={this.beforeLeaving}
                        onConfirmLeave={this.handleConfirmLeave}
                    />
                    {wizard}
                </div>
            );

            content = (

                <section className="account-modify-view__body">
                    <div className="row no-outside-gutter">
                        <div className="account-modify-view__wizard-column col-xs-8">
                            {passContent}
                        </div>
                        <div className="account-modify-view__card-details-column col-xs-4">
                            <CardDetailsSideBar immCard={immCard} />
                        </div>
                    </div>
                </section>
            )
        }
        const mappingBreadcrumb = [
            {
                text: formatText('accountModifyStep-pageTitle'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('accountModifyStep-editAccount')
            }
        ]

        return (
            <article className="account-modify-view">
                <OKHeaderCC
                    title={pageTitle}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                {content}
            </article>
        );
    }
}

CreditModifyAssociatedAccountView.propTypes = {
    modifyCardActions: PropTypes.object,
    history: PropTypes.object.isRequired,
    immCreditCardModifyAccountState: PropTypes.object.isRequired,
    immAccountsState: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCard: PropTypes.object,
    match: PropTypes.object.isRequired,
    postModify: PropTypes.func,
    validateStep: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setCurrentAccount: PropTypes.func.isRequired,
    setNewAccount: PropTypes.func.isRequired,
    finish: PropTypes.func,
    immUserData: PropTypes.object,
    immProfileFields: PropTypes.object,
    requestGetProfile: PropTypes.func,
    getAssociatedAccountDetails: PropTypes.func
}

module.exports.constructor = CreditModifyAssociatedAccountView;
module.exports.CreditModifyAssociatedAccountView = connect(state => ({
    immProfileFields: state.profile,
    immCreditCardModifyAccountState: state.creditModifyAccount,
    immCards: state.cards,
    immAccountsState: state.accounts
}), {
    requestGetProfile: profileActions.requestProfile,
    setWillCancel: modifyCardActions.setWillCancel,
    postModify: modifyCardActions.postModify,
    reset: modifyCardActions.reset,
    setVisibleStep: modifyCardActions.setVisibleStep,
    setNewAccount: modifyCardActions.setNewAccount,
    setCurrentAccount: modifyCardActions.setCurrentAccount,
    validateStep: modifyCardActions.validateStep,
    getAssociatedAccountDetails: modifyCardActions.getAssociatedAccountDetails
})(withRouter(CreditModifyAssociatedAccountView));
